import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import {
  UPDATE_PROJECT_SETTINGS_MUTATION,
  optimisticResponse
} from './graphql';

const mapValuesOnSubmit = values => ({
  projectUri: values.projectUri,
  projectTeamMemberAssignmentType: values.projectTeamMemberAssignmentType
});

export const onSubmit = ({ closeDialog, updateProject }) => (
  values,
  { setSubmitting }
) => {
  const payload = mapValuesOnSubmit(values);

  updateProject({
    variables: {
      projectInput: payload
    },
    optimisticResponse: optimisticResponse(payload)
  });

  closeDialog();
  setSubmitting(false);
};

export const useUpdateProjectSettings = ({ closeDialog }) => {
  const [updateProject] = useMutation(UPDATE_PROJECT_SETTINGS_MUTATION);

  return useCallback(onSubmit({ closeDialog, updateProject }), [
    closeDialog,
    updateProject
  ]);
};
